import { render, staticRenderFns } from "./quizInfo.vue?vue&type=template&id=60ac9975"
import script from "./quizInfo.vue?vue&type=script&lang=js"
export * from "./quizInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports